import { createSlice } from '@reduxjs/toolkit';

export interface BalanceVisibilityState {
  isHidden: boolean;
}

const initialState: BalanceVisibilityState = {
  isHidden: false,
};

const balanceVisibilitySlice = createSlice({
  name: 'balanceVisibility',
  initialState,
  reducers: {
    toggleBalanceVisibility: (state) => {
      state.isHidden = !state.isHidden;
    },
    setBalanceVisibility: (state, action) => {
      state.isHidden = action.payload;
    },
  },
});

export const { toggleBalanceVisibility, setBalanceVisibility } = balanceVisibilitySlice.actions;
export default balanceVisibilitySlice.reducer;